import { invokeAndLogDebugCode, getPostDataArgs, selectConfig } from "./common";
import { getDefaultValue } from '@tencent/data-schema-core';
import { defaultMethodConfig } from "./../utils/consts";
import { getHttpListParamsStrings, getObjectJSONString } from "../utils/code";
import { getEntityPrimaryKey } from "../../stateCommon/getEntityPrimaryKey";
import { FORM_INFOS } from "../formMethods/formInfos";
import { deleteDbReadonlyFields } from "../../common/dbReadonlyFields";
export function getDBParamsCode() {
  return `
  // 这里配置list接口的url参数
  const listParams = {
    page: source.page,
    size: source.size,
    
    // filter格式 [ { k:'id',o:'=',v:'100068' } ]
    filter: source.filter,
    
    sort: source.sort.map(item=>item.k).join(','),
    order: source.sort.map(item=>item.o).join(',')
  }
`;
}
const getDBListCountCode = _options => {
  const code = `
async () => {
  ${getDBParamsCode()}

  // 这里配置count接口的url参数
  const countParams = {
    filter:listParams.filter
  }

  // 发送请求
  const [ listResult , countResult ] = await Promise.all([
    source.$requests.list({ query:listParams }),
    source.$requests.count({ query:countParams })
  ]);

  // 处理list接口的返回结果
  if(listResult.body.code === 0) {
    source.listData = listResult.body.data;
  }else{
    $tips.error({
      content: listResult.body.message
    })
  }
  
  // 处理count接口返回的结果
  if(countResult.body.code === 0) {
    source.total = countResult.body.data.total;
  } else {
    $tips.error({
      content: countResult.body.message
    })
  }

  return {
    listResult,
    countResult
  }
}
`;
  return {
    args: [],
    code
  };
};
export function generateDBListCountMethod(options) {
  const config = selectConfig(options, getDBListCountCode, FORM_INFOS.list.dbListCount);
  return {
    id: 'list',
    title: '请求列表数据',
    ...defaultMethodConfig,
    ...config,
    debugCode: invokeAndLogDebugCode
  };
}
const getDBListCode = _options => {
  const code = `
async () => {

  ${getDBParamsCode()}

  // 发送请求
  const { body } = await source.$requests.list({ query: listParams });

  // 处理list接口的返回结果
  if(body.code === 0) {
    source.listData = body.data ;
  }else{
    $tips.error({
      content: body.message
    })
  }

  return body;
}
  `;
  return {
    args: [],
    code
  };
};
export function generateDBListMethod(options) {
  const config = selectConfig(options, getDBListCode, FORM_INFOS.list.listOrCount);
  return {
    id: 'list',
    title: '请求列表数据',
    ...defaultMethodConfig,
    ...config,
    debugCode: invokeAndLogDebugCode
  };
}
const getDBCountCode = _options => {
  const code = `
async () => {

  // 这里配置count接口的url参数
  const countParams = {
    filter:listParams.filter
  }

  // 发送请求
  const { body } = await source.$requests.count({ query: countParams });

  // 处理list接口的返回结果
  if(body.code === 0) {
    source.total = body.data.total ;
  }else{
    $tips.error({
      message: body.message
    })
  }

  return body;
}
  `;
  return {
    args: [],
    code
  };
};
export function generateDBCountMethod(options) {
  const config = selectConfig(options, getDBCountCode, FORM_INFOS.list.listOrCount);
  return {
    id: 'count',
    title: '请求列表总数',
    ...defaultMethodConfig,
    ...config,
    debugCode: invokeAndLogDebugCode
  };
}
const getHTTPListOrCountCode = options => {
  const {
    cgi
  } = options;
  const [queryString, bodyString] = getHttpListParamsStrings(options);
  const listPath = options.getProtocolPath('list', 'LIST');
  const listTotalPath = options.getProtocolPath('list', 'LIST_TOTAL');
  const totalPath = options.getProtocolPath('count', 'TOTAL');
  const {
    codeString: codePath,
    messageString: messagePath
  } = options.getStringOfCodeMessage(options.cgi);
  const processData = {
    list: `    source.listData = body${listPath};
      // 如果接口有返回总数，就进行写入
      const total = body${listTotalPath};
      if(typeof total === 'number'){
        source.total = total
      }`,
    count: `    source.total = body${totalPath}`
  };
  const query = queryString ? `  // 这里配置list接口的url参数
const params = { 
${queryString}
}` : '';
  const body = bodyString ? `  // 这里配置list接口的post参数
const postData = {
${bodyString}
};` : '';
  const code = `
async () => {

  ${query}
  ${body}

  // 调用list接口
  const { body } = await source.$requests.${cgi}({
    ${[queryString ? 'query: params,' : '', bodyString ? ' body: postData' : ''].join('\n')}
  });

  // 处理list接口的返回结果
  if (${codePath} === 0) {
    ${processData[cgi]}
  } else {
    $tips.error({
      content: ${messagePath}
    })
  }

  return body;
}
`;
  return {
    args: [],
    code
  };
};
export function generateHTTPListOrCountMethod(options) {
  const config = selectConfig(options, getHTTPListOrCountCode, FORM_INFOS.list.listOrCount);
  return {
    id: options.cgi,
    title: '获取列表数据',
    ...defaultMethodConfig,
    ...config,
    debugCode: invokeAndLogDebugCode
  };
}
export function generateListOrCountMethod(options) {
  if (options.collection.type === 'http') {
    return generateHTTPListOrCountMethod(options);
  }
  // 以下都是db的
  if (options.cgi === 'list') {
    return generateDBListMethod(options);
  }
  if (options.cgi === 'count') {
    return generateDBCountMethod(options);
  }
  throw new Error('generateListOrCountMethod cgi error');
}
export function generateNewItemMethod(options) {
  const {
    collection,
    isFreeType
  } = options;
  const {
    entity
  } = collection;
  const defaultItem = entity ? getDefaultValue(entity) : {};
  if (!isFreeType) {
    deleteDbReadonlyFields(defaultItem);
  }
  const code = `
async ()=>{
  
  const item = ${getObjectJSONString(defaultItem)}
  
  source.listData.push(item);

  return item;
}
`;
  return {
    id: 'newItem',
    title: '新建一行空数据,不提交',
    ...defaultMethodConfig,
    args: [],
    code,
    debugCode: invokeAndLogDebugCode
  };
}
export function generateSaveMethod(options) {
  const {
    collection
  } = options;
  const key = getEntityPrimaryKey(collection);
  const code = `
async (postData)=>{
  if(postData['${key || 'id'}']){
    // 有id，说明该数据已经存在，调用update方法
    return await source.$methods.update( postData );
  }else {
    // id为空,调用create方法
    return await source.$methods.create( postData );
  }
}
`;
  return {
    id: 'save',
    title: '保存-新建或更新',
    ...defaultMethodConfig,
    args: getPostDataArgs(),
    code,
    debugCode: invokeAndLogDebugCode
  };
}
export function generateSaveSelectedMethod(_options) {
  const code = `
async () => {
    if (source.selectedItems.length <= 0) {
      $message.warn('未有选中行');
      return;
    }
  
    const promises = source.selectedItems.map((item) => source.$methods.save(item))
    const res = await Promise.all(promises);
    // 删除后进行清空
    source.selectedItems = [];
    return res;
  } 
  `;
  return {
    id: 'saveSelected',
    title: '批量-保存已选中行',
    ...defaultMethodConfig,
    args: [],
    code,
    debugCode: invokeAndLogDebugCode
  };
}
export function generateDeleteSelectedMethod(_options) {
  const code = `
async () => {
  if (source.selectedItems.length <= 0) {
    $message.warn('未有选中行');
    return;
  }

  const promises = source.selectedItems.map((item) => source.$methods.delete(item))
  const res = await Promise.all(promises);
  // 删除后进行清空
  source.selectedItems = [];
  return res;
} 
`;
  return {
    id: 'deleteSelected',
    title: '批量-删除已选中行',
    ...defaultMethodConfig,
    args: [],
    code,
    debugCode: invokeAndLogDebugCode
  };
}
export function generateListItemCopyMethod(options) {
  const {
    collection
  } = options;
  const key = getEntityPrimaryKey(collection) || 'id';
  const code = `
async (item) => {
  // 深拷贝一份数据
  const newItem = $utils.cloneDeep(item);

  // 删除主键
  delete newItem.${key};

  // 将复制的数据添加到列表尾部
  source.listData.push(newItem);

  return newItem;
}
  `;
  return {
    id: 'copy',
    title: '复制数据',
    ...defaultMethodConfig,
    args: [{
      id: 'item',
      title: '需要复制的数据'
    }],
    code,
    debugCode: invokeAndLogDebugCode
  };
}
//# sourceMappingURL=list.js.map
